import React, { useContext, useRef, useEffect, useState } from "react";
import { RadioGroup, Field, Radio } from "@headlessui/react";
import { HiCheck, HiOutlineChartBar, HiOutlineSquares2X2 } from "react-icons/hi2";
import { ProductsContext } from "../context/products.context";
import clsx from "clsx";

const VIEW_OPTIONS = [
  { value: "bar", icon: HiOutlineChartBar, label: "Bar chart view" },
  { value: "grid", icon: HiOutlineSquares2X2, label: "Grid view" },
];

const PerkinsViewToggle = () => {
  const { viewType, setViewType } = useContext(ProductsContext);
  
  // Track the selected option's element and its dimensions
  const optionRefs = useRef([]);
  const [activeStyles, setActiveStyles] = useState({ left: 0, width: 0 });
  
  // Update active indicator dimensions whenever selection changes
  useEffect(() => {
    const selectedIndex = VIEW_OPTIONS.findIndex(
      (option) => option.value === viewType
    );
    
    if (selectedIndex < 0) return;
    
    const selectedElement = optionRefs.current[selectedIndex];
    
    if (selectedElement) {
      const rect = selectedElement.getBoundingClientRect();
      setActiveStyles({
        width: rect.width,
        left: selectedElement.offsetLeft
      });
    }
  }, [viewType]);

  return (
    <div className="max-w-md mx-auto select-none ">
      <RadioGroup
        value={viewType}
        onChange={setViewType}
        className="relative bg-zinc-100 rounded-full border-zinc-200 border p-1 shadow-inner flex gap-x-1"
      >
        {/* Active background indicator - sized to match the selected option exactly */}
        <div
          className="absolute transition-all duration-200 ease-out top-1 bottom-1 rounded-full bg-white shadow-md"
          style={{
            width: activeStyles.width ? `${activeStyles.width}px` : '0',
            left: activeStyles.left ? `${activeStyles.left}px` : '4px',
          }}
        />
        
        {VIEW_OPTIONS.map((option, idx) => {
          const isSelected = viewType === option.value;
          
          return (
            <Field
              as="div"
              key={option.value}
              ref={el => optionRefs.current[idx] = el}
              className="relative z-10 flex-1"
            >
              <Radio
                value={option.value}
                className={({ checked }) =>
                  clsx(
                    "w-full h-full flex items-center justify-center rounded-full py-2.5 px-4 font-medium focus:outline-none cursor-pointer",
                    {
                      "text-zinc-900": checked,
                      "text-zinc-600 hover:bg-zinc-300": !checked,
                    }
                  )
                }
              >
                {({ checked }) => (
                  <>
                    <span className="sr-only">
                      {option.label}
                    </span>
                    {checked && <HiCheck className="w-8 h-4 -mr-4" />}
                    {React.createElement(option.icon, { 
                      className: "w-5 h-5 mx-2"
                    })}
                  </>
                )}
              </Radio>
            </Field>
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default PerkinsViewToggle;